/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerExperienceType } from './PartnerExperienceType';
import {
    PartnerExperienceTypeFromJSON,
    PartnerExperienceTypeFromJSONTyped,
    PartnerExperienceTypeToJSON,
    PartnerExperienceTypeToJSONTyped,
} from './PartnerExperienceType';
import type { PartnerThemeTokens } from './PartnerThemeTokens';
import {
    PartnerThemeTokensFromJSON,
    PartnerThemeTokensFromJSONTyped,
    PartnerThemeTokensToJSON,
    PartnerThemeTokensToJSONTyped,
} from './PartnerThemeTokens';
import type { PartnerAuthMode } from './PartnerAuthMode';
import {
    PartnerAuthModeFromJSON,
    PartnerAuthModeFromJSONTyped,
    PartnerAuthModeToJSON,
    PartnerAuthModeToJSONTyped,
} from './PartnerAuthMode';

/**
 * Represents a Partner Service that we integrate with.
 * @export
 * @interface PartnerService
 */
export interface PartnerService {
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    utmSource?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    referralCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    gameIdField?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    oAuthClientId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    logoAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    headerBgAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    brandColor?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    tagline?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PartnerService
     */
    loginBenefits?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PartnerService
     */
    welcomeEmailTemplateId?: string;
    /**
     * 
     * @type {PartnerAuthMode}
     * @memberof PartnerService
     */
    authMode?: PartnerAuthMode;
    /**
     * 
     * @type {PartnerThemeTokens}
     * @memberof PartnerService
     */
    themeTokens?: PartnerThemeTokens;
    /**
     * 
     * @type {Array<PartnerExperienceType>}
     * @memberof PartnerService
     */
    enabledExperiences?: Array<PartnerExperienceType>;
    /**
     * 
     * @type {number}
     * @memberof PartnerService
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerService
     */
    updatedAt?: number;
}



/**
 * Check if a given object implements the PartnerService interface.
 */
export function instanceOfPartnerService(value: object): value is PartnerService {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PartnerServiceFromJSON(json: any): PartnerService {
    return PartnerServiceFromJSONTyped(json, false);
}

export function PartnerServiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerService {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'utmSource': json['utmSource'] == null ? undefined : json['utmSource'],
        'referralCode': json['referralCode'] == null ? undefined : json['referralCode'],
        'gameIdField': json['gameIdField'] == null ? undefined : json['gameIdField'],
        'oAuthClientId': json['oAuthClientId'] == null ? undefined : json['oAuthClientId'],
        'logoAssetId': json['logoAssetId'] == null ? undefined : json['logoAssetId'],
        'headerBgAssetId': json['headerBgAssetId'] == null ? undefined : json['headerBgAssetId'],
        'brandColor': json['brandColor'] == null ? undefined : json['brandColor'],
        'tagline': json['tagline'] == null ? undefined : json['tagline'],
        'loginBenefits': json['loginBenefits'] == null ? undefined : json['loginBenefits'],
        'welcomeEmailTemplateId': json['welcomeEmailTemplateId'] == null ? undefined : json['welcomeEmailTemplateId'],
        'authMode': json['authMode'] == null ? undefined : PartnerAuthModeFromJSON(json['authMode']),
        'themeTokens': json['themeTokens'] == null ? undefined : PartnerThemeTokensFromJSON(json['themeTokens']),
        'enabledExperiences': json['enabledExperiences'] == null ? undefined : ((json['enabledExperiences'] as Array<any>).map(PartnerExperienceTypeFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function PartnerServiceToJSON(json: any): PartnerService {
    return PartnerServiceToJSONTyped(json, false);
}

export function PartnerServiceToJSONTyped(value?: PartnerService | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'utmSource': value['utmSource'],
        'referralCode': value['referralCode'],
        'gameIdField': value['gameIdField'],
        'oAuthClientId': value['oAuthClientId'],
        'logoAssetId': value['logoAssetId'],
        'headerBgAssetId': value['headerBgAssetId'],
        'brandColor': value['brandColor'],
        'tagline': value['tagline'],
        'loginBenefits': value['loginBenefits'],
        'welcomeEmailTemplateId': value['welcomeEmailTemplateId'],
        'authMode': PartnerAuthModeToJSON(value['authMode']),
        'themeTokens': PartnerThemeTokensToJSON(value['themeTokens']),
        'enabledExperiences': value['enabledExperiences'] == null ? undefined : ((value['enabledExperiences'] as Array<any>).map(PartnerExperienceTypeToJSON)),
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

